import template from './positions.html';
import controller from './positions.controller';

export default {
  restrict: 'E',
  bindings: {
    oldPositions: '<',
    transfer: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};



// WEBPACK FOOTER //
// ./src/app/common/ui/positions/positions.component.js